<template>
    <loader-overlay-logo></loader-overlay-logo>
</template>

<script>

import HandlesFilters from "../../Mixins/HandlesFilters.js";
import LoaderOverlayLogo from '../General/LoaderOverlayLogo.vue';

export default {

    name: 'DetailDataHandlerPark',

    components: {LoaderOverlayLogo},

    mixins: [HandlesFilters],

    props: ['prefix', 'initial-url'],

    data() {
        return {
            url: null,
            prefixUrl: this.prefix,
        }
    },

    created() {
        this.url = this.initialUrl;
    },

    mounted() {
        this.getData(this.initialUrl);

        this.Bus.on('filter-change', (cancels = null) => {
            this.buildAndGet();
        });

        this.Bus.on('filter-change-silent', (reference) => {
            this.buildAndGet();
        });

        this.Bus.on('calendar-change', (data) => {

        });

        this.Bus.on('popup-handle-apply', (reference) => {
            if (reference === 'arrival') {
                this.buildAndGet();
            }
        });
    },

    methods: {
        getData(url = null) {

            url = url ?? this.url;

            axios.post(url)
                .then(response => {

                    // console.log(response.data.content);

                    history.pushState(null, null, url);

                    if (response.data.content) {
                        this.Bus.emit('render-view', {
                            reference: 'park-houses',
                            content: response.data.content,
                        });
                    }

                    if (response.data.count) {
                        const target = document.querySelector('div[data-section-reference="holiday-homes"] small');
                        target.innerHTML = '(' + response.data.count + ')';
                    }

                    this.Bus.emit('stop-loading', 'park-houses');

                })
                .catch(error => {

                    this.Bus.emit('stop-loading', 'park-houses');

                    console.log('ERROR:');
                    console.log(error);

                });
        },

        buildAndGet() {
            this.Bus.emit('start-loading', 'park-houses');

            this.buildAll();
            this.getData();
        }
    },
}

</script>

